let cachedResults = null;
function getLanguageJson(){
    let jsonResult = {};
    if(cachedResults == null){
        $.ajax({
            url:window.filterTranslateJsonUrl,
            dataType: 'json',
            async: false
        }).done(function(json) {
            jsonResult = json;
            cachedResults = jsonResult;
        }).fail(function(error) {
            console.log(error)
        });
    }
    return cachedResults;
}
function translateFilter() {
    let languageJson= getLanguageJson();
    
    const curent_language_translate = languageJson.languages.find((element => element.language === Shopify.locale));
    const filter_values = document.querySelectorAll('[data-filter-value]');
    if(curent_language_translate) {
        filter_values.forEach(function (value, index) {
            let filter_value = value.innerHTML.replace(":", "").trim();
            let curent_translate = curent_language_translate.translate.find(translate => Object.keys(translate).toString().toLowerCase() === filter_value.toLowerCase())
            if (curent_translate) {
                value.innerHTML = Object.values(curent_translate);
            }
        });
    }
}
translateFilter()